import { isAccountType } from '@pulsify/shared/auth-roles'
import { createFileRoute } from '@tanstack/react-router'
import { SetPasswordFlow } from '~/features/auth/set-password-flow'
import * as m from '~/paraglide/messages'

export const Route = createFileRoute('/reset-password')({
  validateSearch: (search: Record<string, unknown>) => ({
    role: isAccountType(search.role) ? search.role : 'business',
  }),
  component: ResetPasswordPage,
})

function ResetPasswordPage() {
  const { role } = Route.useSearch()
  return (
    <SetPasswordFlow
      tokenType="recovery"
      role={role}
      title={m.resetPassword()}
      description={m.enterANewPasswordForYourAccount()}
      successTitle={m.passwordResetSuccessful()}
      successDescription={m.yourPasswordHasBeenResetSuccessfullyYouWillBeRedirectedToTheLoginPageShortly()}
      submitIdleLabel={m.resetPassword2()}
      submitPendingLabel={m.resettingPassword()}
      noTokenHelp={m.openThisPageFromTheLinkInYourPasswordResetEmail()}
      signInFooter
    />
  )
}
